import styled, { createGlobalStyle } from 'styled-components';
import { Card } from '@/components/card';
import { DeviceType } from '@/utils/definitions';

export const Wrapper = styled(Card)`
  && {
    font-family: Inter, serif;
    cursor: ${(props: { device: DeviceType; isSynced: boolean }) =>
      props.isSynced ? `pointer` : `default`};
    line-height: 1.8;
    border-radius: 1.8rem;
    min-height: 7rem;
    padding: ${(props: { device: DeviceType; isSynced: boolean }) =>
      props.device === DeviceType.Desktop
        ? `1rem 0 1rem 2rem`
        : `1rem 0 1rem 2rem`};
    display: grid;
    grid-template-columns: ${(props: {
      device: DeviceType;
      isSynced: boolean;
    }) =>
      props.device === DeviceType.Desktop
        ? `2rem 1fr 7.5rem`
        : `2rem 1fr 6.5rem`};
    grid-column-gap: ${(props: { device: DeviceType; isSynced: boolean }) =>
      props.device === DeviceType.Desktop ? `1.8rem` : `2rem`};
    align-items: center;
    border: 2px solid rgba(151, 151, 151, 0.1);
    box-shadow: 0 10px 20px 0 rgba(177, 217, 203, 0.18),
      0 2px 15px 0 rgba(0, 0, 0, 0.05);
  }
`;
export const Ordinal = styled.div`
  font-family: Inter, serif;
  font-size: ${(props: { device: DeviceType }) =>
    props.device === DeviceType.Desktop ? `2rem` : `2.2rem`};
  font-weight: 500;
  letter-spacing: 0.47px;
  color: #c4d0dc;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Title = styled.span`
  color: #8f969d;
  letter-spacing: -0.47px;
  font-size: ${(props: { device: DeviceType }) =>
    props.device === DeviceType.Desktop ? `1.2rem` : `1.4rem`};
  font-weight: normal;

  u {
    text-decoration-thickness: 0.15rem;
  }

  b {
    color: black;
    font-weight: bold;

    :hover {
      text-decoration: underline;
    }
  }
`;
export const Icon = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5rem;

  cursor: context-menu;

  :hover {
    opacity: 0.6;
  }
`;
export const Controls = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
`;
export const StyledTooltip = createGlobalStyle`
  .exp-options-tooltip-cls {
    border-radius: 1rem!important;
    box-shadow: 0 12px 18px 2px rgba(0,0,0,0.14), 0 5px 23px 4px rgba(0,0,0,0.12), 0 6px 8px -4px rgba(0,0,0,0.2)!important;
    padding: 0!important;
    width: 18rem;
    opacity: 1!important;

    font-family: Inter, serif;
  }
`;
export const TooltipRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1.5rem;
  border-top: 1px solid transparent;
  padding: 1.5rem 2rem;
  align-items: center;

  img {
    object-fit: contain !important;
  }

  transition: background-color 0.3s linear;

  :hover {
    background: #fafafa;
  }
`;
export const ChangeTargetWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #8e969d;

  button {
    background: transparent !important;
    text-decoration: none;
    cursor: ${(props: { device: DeviceType; allowEdit: boolean }) =>
      props.allowEdit ? `pointer` : `default`};
    display: flex;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    color: #000000 !important;
    text-transform: initial;
    font-size: ${(props: { device: DeviceType; allowEdit: boolean }) =>
      props.device === DeviceType.Desktop ? `1.2rem` : `1.4rem`};
    margin-left: 0.6rem;
    padding: ${(props: { device: DeviceType; allowEdit: boolean }) =>
      props.device === DeviceType.Desktop ? `0.5rem 0` : `0.6rem 0`};

    .gatsby-image-wrapper {
      margin-left: 0.8rem;
    }
  }
`;
export const PopoverWrapper = styled.div`
  display: flex;
  background: white;
  flex-direction: column;
  justify-content: center;

  font-family: Inter, sans-serif;
  font-size: 1.3rem;
  font-weight: 500;
  color: #8d99ae;
  border-radius: 1rem;
  box-shadow: 0 8px 10px 0 rgba(105, 122, 231, 0.11),
    0 23px 32px 0 rgba(196, 217, 210, 0.38), 0 2px 10px 0 rgba(0, 0, 0, 0.15);

  & > div {
    cursor: pointer;
    display: grid;
    grid-template-columns: 2rem 1fr;
    grid-gap: 1rem;
    justify-content: flex-start;
    align-items: center;
    min-height: 4.3rem;
    padding: 0 5rem 0 2rem;

    .gatsby-image-wrapper {
      opacity: 0;

      img {
        height: 1.3rem;
        width: 1.3rem;
      }
    }

    :hover {
      opacity: 0.8;
    }
  }

  div.vsly-selected {
    color: #3451fa;

    .gatsby-image-wrapper {
      opacity: 1;
    }
  }

  div:not(:first-child) {
    border-top: 1px solid rgba(151, 151, 151, 0.25);
  }
`;
